'use client';

import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';
import { CollapseArrowDownOutlined, CollapseArrowUpOutlined } from '@zeelool/icon';
import { useState } from 'react';

const Faq = ({ memberPrivileges }: { memberPrivileges: any }) => {
  const { qa, qa_title } = memberPrivileges;
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleToggle = (panel: string) => {
    setExpanded((current) => (current === panel ? false : panel));
  };

  if (!qa) {
    return null;
  }

  return (
    <>
      <WebOnly>
        <div className="mx-auto mt-[100px] max-w-[1200px] px-4">
          <h2 className="mb-8 text-center text-32 font-bb">{qa_title}</h2>
          <div className="mx-auto w-4/5 border-t border-[#e0e0e0] mt-[32px]">
            {qa.map((item: any) => {
              const isExpanded = expanded === `panel${item.id}`;
              return (
                <div key={item.id} className="border-b border-[#e0e0e0]">
                  <button
                    type="button"
                    onClick={() => handleToggle(`panel${item.id}`)}
                    className="flex w-full items-center justify-between py-16 text-left"
                    aria-expanded={isExpanded}
                    aria-controls={`panel${item.id}-content`}
                  >
                    <span className="font-bb text-16">{item.question}</span>
                    {isExpanded ? <CollapseArrowUpOutlined /> : <CollapseArrowDownOutlined />}
                  </button>
                  {isExpanded && (
                    <div id={`panel${item.id}-content`} className="pb-14 text-14">
                      <p>{item.answer}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </WebOnly>
      <WapOnly>
        <div className="px-14 max-w-[1200px]  bg-[#ecebfc]">
          <h2 className="mb-8 text-center text-20 font-bb pt-32">{qa_title}</h2>
          <div className=" border-t border-[#d4d4d4] mt-[32px]">
            {qa.map((item: any) => {
              const isExpanded = expanded === `panel${item.id}`;
              return (
                <div key={item.id} className="border-b border-[#d4d4d4]">
                  <button
                    type="button"
                    onClick={() => handleToggle(`panel${item.id}`)}
                    className="flex w-full items-center justify-between py-16 text-left"
                    aria-expanded={isExpanded}
                    aria-controls={`panel${item.id}-content`}
                  >
                    <span className="font-bb text-14">{item.question}</span>
                    {isExpanded ? <CollapseArrowUpOutlined /> : <CollapseArrowDownOutlined />}
                  </button>
                  {isExpanded && (
                    <div id={`panel${item.id}-content`} className="pb-14 text-14">
                      <p className="leading-[18px]">{item.answer}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </WapOnly>
    </>
  );
};

export default Faq;
